import Http from '../http'

export default {

  indexUsers() {
    return Http.get(`/users`)
  },

  indexCompanies() {
    return Http.get(`/companies`, {params: {config: true}})
  },

  updateCompanies(company){
    return Http.put(`/companies/${company.id}`, {
      company: {
        status: company.status,
      },
    });
  },

  // show(id) {
  //   return Http.get(`/users/${id}`);
  // },

  // delete(id){
  //   return Http.delete(`/users/${id}`)
  // }

}
